import React, {memo, useCallback, useEffect, useState} from 'react';
import noImage from '../../assets/images/no-image.png';
import {useInterval} from '../../hooks/interval';
import {Configs} from '../../configs';

type Props =
    { interval?: number; disableErrorHandling?: boolean; disablePrefix?: boolean; }
    & React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;
export const Image = memo(function Image(props: Props) {
    const {src: source, disableErrorHandling, disablePrefix, interval: rawInterval, alt, ...restOfProps} = props;

    const [hasError, setHasError] = useState(false);
    const [interval, setInterval] = useState(rawInterval);
    const [src, setSrc] = useState(source);
    const [randomValue, setRandomValue] = useState(0);

    useInterval(useCallback(() => setRandomValue(Math.random()), []), interval);

    const onError = useCallback(() => {
        setInterval(null);
        setHasError(true);
        //setSrc(noImage);
    }, [hasError, disableErrorHandling]);

    useEffect(() => {
        if (hasError) {
            console.log(source)
            setSrc((disablePrefix ? '' : Configs.IMAGE_PREFIX) + src + (randomValue ? '?rand=' + randomValue : ''));
            return;
        }

        //setInterval(5000);
    }, [hasError, rawInterval]);

    useEffect(() => {
        setHasError(false);
        setSrc(source);
    }, [source]);

    return (
        <img
            {...restOfProps}
            alt={alt}
            src={(disablePrefix ? '' : Configs.IMAGE_PREFIX) + src + (randomValue ? '?rand=' + randomValue : '')}
            onError={onError}
        />
    );
});
